import React from "react";
import { Link } from "react-router-dom";

type NavLinkItem = {
    label: string;
    link: string;
    external?: boolean;
    img?: string;
    customClass?: string;
    target?: string; // optional override
};

type Props = {
    link: NavLinkItem;
};

export const FooterLink: React.FC<Props> = ({ link }) => {
    const baseClass =
        "border-b border-transparent hover:border-current w-fit";
    const className = `${baseClass} ${link.customClass ?? ""}`.trim();

    if (link.external) {
        return (
            <a
                href={link.link}
                className={`inline-flex items-center justify-center gap-1 ${className}`}
                target={link.target} // e.g. "_blank"
                rel={link.target === "_blank" ? "noreferrer noopener" : undefined}
            >
                <span className="font-atkinsonHyperlegible text-18 leading-[140%]">{link.label}</span>
                {link.img && <img src={link.img} alt="" className="w-[22px] h-[12px] self-center" />}
            </a>
        );
    }

    return (
        <Link to={link.link} className={className} target={link.target ?? "_blank"}>
            <span className="font-atkinsonHyperlegible text-18 leading-[140%]">{link.label}</span>
        </Link>
    );
};

export default FooterLink;